import { NavAutenticated, NavBtn, NavBtnLink, NavItem, NavLinkAutenticated, NavMenu } from "./styles"
import { LogoAuthenticated, LogoChristmasAuthenticated } from "./svg"
import { isChristmas } from 'helper/date'
import { Link } from 'react-router-dom'
import { ROUTES_NAMES } from 'constants/name.routes'

export const NavBarAuthenticatedComponent = ({
    currentProfile,
    profile,
    currentUser,
    handleLogout,
    initialsUser
}: {
    currentProfile: string
    profile: string
    currentUser: string
    handleLogout: () => void
    initialsUser: string
}) => {
    let logo = <LogoAuthenticated/>
    if (isChristmas()) {
      logo = <LogoChristmasAuthenticated />
    }
    return (
        <NavAutenticated>
            <NavItem>
                <NavItem>
                    <Link to={ROUTES_NAMES.notifications} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                        {logo}
                    </Link>
                </NavItem>
                <NavMenu>
                    <NavLinkAutenticated to="/notificacoes">
                        {' '}
                        Notificações{' '}
                    </NavLinkAutenticated>
                    <NavLinkAutenticated to="/relatorios">
                        {' '}
                        Relatórios{' '}
                    </NavLinkAutenticated>
                    {currentProfile === 'admin' ||
                        currentProfile === 'corporate_quality_management' ||
                        currentProfile === 'corporate_quality_board' ? (
                        <NavLinkAutenticated to="/configuracoes">
                            {' '}
                            Configurações{' '}
                        </NavLinkAutenticated>
                    ) : null}
                    <NavLinkAutenticated to="/notificar-evento">
                        Notificar um evento
                    </NavLinkAutenticated>
                </NavMenu>
            </NavItem>

            <NavBtn>
                <div style={{ color: '#F0B323' }} id={'current-user'}>
                    Olá
                </div>
                &nbsp;
                <div title={profile} style={{ color: 'white' }}>
                    {currentUser}
                    {'\n'}
                </div>
                <NavBtnLink to="#" onClick={handleLogout}>
                    {initialsUser}
                </NavBtnLink>
            </NavBtn>
        </NavAutenticated>
    )
}